import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const PdfIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M8.123 13.902h-.312v1.044h.238c.104 0 .2-.017.287-.05a.479.479 0 0 0 .218-.179.607.607 0 0 0 .081-.33.493.493 0 0 0-.125-.351c-.083-.09-.212-.134-.387-.134ZM12.897 15.131c0-.276-.037-.505-.112-.687a.796.796 0 0 0-.325-.408 1.003 1.003 0 0 0-.543-.134h-.35v2.547h.269c.366 0 .635-.108.805-.325.17-.216.256-.547.256-.993Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M4.809 21 4 20.182V3.818L4.809 3h9.888l.572.24 4.494 4.545.237.579v11.818l-.809.818H4.809ZM15.146 7.91V4.915l2.96 2.993h-2.96Zm-6.998 5c.566 0 .989.124 1.267.375.283.25.425.607.425 1.07 0 .207-.03.407-.088.598a1.356 1.356 0 0 1-.805.866 2.196 2.196 0 0 1-.799.127h-.337v1.509H6.607v-4.546h1.541Zm5.997 2.176c0 .527-.097.966-.293 1.318a1.84 1.84 0 0 1-.811.79c-.35.174-.762.26-1.236.26h-1.442V12.91h1.542c.478 0 .884.085 1.217.255.333.165.587.41.761.732.175.322.262.72.262 1.19Zm.614 2.369h1.186v-1.706h1.336v-.987h-1.336v-.866h1.448v-.987H14.76v4.546Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M8.148 12.909c.566 0 .989.125 1.267.376.283.25.425.607.425 1.07 0 .207-.03.407-.088.598a1.353 1.353 0 0 1-.805.866 2.196 2.196 0 0 1-.799.127h-.337v1.508H6.607V12.91h1.541Zm-.025.993h-.312v1.044h.238c.104 0 .2-.017.287-.05a.48.48 0 0 0 .218-.179.607.607 0 0 0 .081-.331.493.493 0 0 0-.125-.35c-.083-.09-.212-.134-.387-.134ZM14.145 15.086c0 .527-.097.966-.293 1.318a1.839 1.839 0 0 1-.811.79c-.35.174-.762.26-1.236.26h-1.442V12.91h1.542c.478 0 .884.085 1.217.255.333.165.587.41.761.732.175.322.262.72.262 1.19Zm-1.248.045a1.82 1.82 0 0 0-.112-.688.795.795 0 0 0-.325-.407 1.003 1.003 0 0 0-.543-.134h-.35v2.547h.269c.366 0 .635-.109.805-.325.17-.216.256-.548.256-.993Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M14.76 17.455h1.185v-1.707h1.336v-.986h-1.336v-.866h1.448v-.987H14.76v4.545Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m4 20.182.809.818h14.382l.809-.818V8.364l-.237-.579L15.27 3.24 14.697 3H4.809L4 3.818v16.364Zm1.618-.818V4.636h8.315v3.728l.764.772h3.685v10.228H5.618Zm9.843-13.616 1.822 1.843H15.46V5.748Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `PdfIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { PdfIcon };
//# sourceMappingURL=PdfIcon.mjs.map
